export default function Faq2() {
  
  //@CF fill in 
  return (
    <div>
      <h2 className="faq-header">Why provide biometric data?</h2>
      <div className="faq-content">
        <p>
          Providing Biometric data is helpful to understand the thermal comfort tailored to your personal needs. The predictions are therefore much more accurate.
        </p>
      </div>
    </div>
  );
}
